module.exports = __webpack_public_path__ + "static/media/image-card-1.47c82405.png";